"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Espilon Text Editor Module
 */
var EpsilonTextEditor = /** @class */ (function () {
    /**
     * Class Constructor
     * @param {{container: JQuery; params: {value: number; id: string}}} control
     */
    function EpsilonTextEditor(control, repeater, deconstruct) {
        if (repeater === void 0) { repeater = false; }
        if (deconstruct === void 0) { deconstruct = false; }
        this.context = jQuery(control.container);
        this.editorId = control.params.id + '-editor';
        if (repeater) {
            this.editorId = control.params.id;
        }
        if (deconstruct) {
            wp.editor.remove(this.editorId);
        }
        this.init();
    }
    /**
     * Text editor initiator
     */
    EpsilonTextEditor.prototype.init = function () {
        wp.editor.initialize(this.editorId, {
            tinymce: {
                wpautop: true,
                browser_spellcheck: true,
                mediaButtons: false,
                wp_autoresize_on: true,
                toolbar1: 'bold,italic,link,strikethrough',
                setup: function (editor) {
                    editor.on('change', function (e) {
                        editor.save();
                        jQuery(editor.getElement()).trigger('change');
                    });
                }
            },
            quicktags: true
        });
    };
    return EpsilonTextEditor;
}());
exports.EpsilonTextEditor = EpsilonTextEditor;



//////////////////
// WEBPACK FOOTER
// ./assets/vendors/epsilon-framework/customizer/controls/text-editor.ts
// module id = 2
// module chunks = 0